import React from 'react';
import './Dashboard.scss';
import dashboardImage from '../../resources/images/dashboard_user.png';
import HrbTranslate from "../language/HrbTranslate";
import ExternalLink from "../link/ExternalLink";

const DashboardDocumentLinkPanel = (props) => (
    <div className="hrb-dashboard-document-list-container">
        <img className="hrb-dashboard-portal-user-img" src={dashboardImage} alt="dashboardImage"/>
        <div className="hrb-dashboard-document-list-container-highlight">
        <div className="hrb-dashboard-document-list-content">
            <HrbTranslate text="dashboard.document_list_text"/>
            <ExternalLink linkKey="links.document_checklist" isNewWindow={true}>
                <HrbTranslate text="dashboard.document_list_link"/>
                <i className="la la-angle-right"/>
            </ExternalLink>
        </div>
        </div>
    </div>
);

export default DashboardDocumentLinkPanel;